/**
 * Wissensdatenbank je Betrieb (Paul, 01.10.2026): Fakten darüber, wie der
 * Betrieb arbeitet — aus seinen eigenen Mails gelernt und geprüft. Gemeinsame
 * Typen und Texte für den Block an der Mail und die Seite unter „Intern".
 */
export type FaktArt = "absage" | "rueckfrage" | "ablauf" | "termine" | "preise" | "firma" | "kontakt" | "leistung"
export type FaktStatus = "gilt" | "bestaetigen" | "abgelehnt" | "vorgeschlagen"

export type Fakt = {
  id: number
  tenant_slug: string
  art: FaktArt
  bezug: string
  aussage: string
  dauer: "dauerhaft" | "voruebergehend"
  status: FaktStatus
  grund: string | null
  /** Beleg-IDs (m…/a…) — nur als Anzahl zeigen, nie die IDs selbst. */
  belege: string[]
  n_kunden: number
  erster_beleg: string | null
  letzter_beleg: string | null
  verfaellt_am: string | null
  verfallen: boolean
  quelle: string | null
  entschieden_von: string | null
  entschieden_at: string | null
  erstellt_at: string | null
  aktualisiert_at: string | null
}

export type LetzterLauf = {
  id: number
  art: string
  gestartet_at: string | null
  beendet_at: string | null
  kosten_usd: number | null
  bilanz: unknown
}

export type BetriebswissenAntwort = {
  tenant: string
  fakten: Fakt[]
  letzter_lauf: LetzterLauf | null
  zaehlung: Record<FaktStatus, number>
}

/** Kurzes Etikett je Art (am Fakt). */
export const ART_ETIKETT: Record<FaktArt, string> = {
  absage: "Absage",
  rueckfrage: "Rückfrage",
  ablauf: "Ablauf",
  termine: "Termine",
  preise: "Preise",
  firma: "Firma",
  kontakt: "Kontakt",
  leistung: "Leistung",
}

/** Überschriften der Gruppen auf der Seite, in dieser Reihenfolge. */
export const ART_GRUPPE: [FaktArt, string][] = [
  ["absage", "Absagen"],
  ["rueckfrage", "Rückfragen"],
  ["ablauf", "Abläufe"],
  ["termine", "Termine"],
  ["preise", "Preise"],
  ["firma", "Firma"],
  ["kontakt", "Kontakt"],
  ["leistung", "Leistungen"],
]

/** "2026-10-14" → "14.10." (ohne Date-Objekt, also ohne Zeitzonen-Versatz). */
export function tagMonat(iso: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "")
  return m ? `${m[3]}.${m[2]}.` : ""
}

/** "2026-10-14…" → "14.10.2026". */
export function datumLang(iso: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "")
  return m ? `${m[3]}.${m[2]}.${m[1]}` : ""
}

export const wissensdatenbankHref = (tenantSlug?: string | null) =>
  `/wissensdatenbank${tenantSlug ? `?tenant=${encodeURIComponent(tenantSlug)}` : ""}`
